<div class="otp-box">
  <div class="reset-intro">
    <h2>Reset password</h2>
    <p>Enter the OTP sent to {{ contact }}, then choose a new password.</p>
  </div>

  <form [formGroup]="form" (ngSubmit)="submitted.emit()">
    <div class="form-group">
      <label for="forgotOtp">OTP</label>
      <input id="forgotOtp" formControlName="otp" type="text" inputmode="numeric"
        autocomplete="one-time-code" maxlength="6" placeholder="Enter 6-digit OTP" />
    </div>

    <div class="form-group">
      <label for="forgotPassword">New password</label>
      <div class="password-input">
        <input id="forgotPassword" formControlName="password"
          [type]="isPasswordVisible ? 'text' : 'password'"
          autocomplete="new-password" placeholder="Enter new password" />
        <button type="button" class="password-visibility" [class.is-visible]="isPasswordVisible"
          [attr.aria-label]="isPasswordVisible ? 'Hide new password' : 'Show new password'"
          [attr.aria-pressed]="isPasswordVisible"
          (click)="isPasswordVisible = !isPasswordVisible"></button>
      </div>
    </div>

    <div class="form-group">
      <label for="forgotConfirmPassword">Confirm password</label>
      <div class="password-input">
        <input id="forgotConfirmPassword" formControlName="confirmPassword"
          [type]="isConfirmPasswordVisible ? 'text' : 'password'"
          autocomplete="new-password" placeholder="Re-enter new password" />
        <button type="button" class="password-visibility" [class.is-visible]="isConfirmPasswordVisible"
          [attr.aria-label]="isConfirmPasswordVisible ? 'Hide confirm password' : 'Show confirm password'"
          [attr.aria-pressed]="isConfirmPasswordVisible"
          (click)="isConfirmPasswordVisible = !isConfirmPasswordVisible"></button>
      </div>
    </div>

    @if (errorText) {
    <small class="error-text" role="alert">{{ errorText }}</small>
    }

    <button type="submit" class="verify-btn" [disabled]="isLoading">
      @if (isLoading) {
      <span class="spinner" role="status" aria-label="Updating password"></span>
      } @else { Update password }
    </button>
  </form>

  <button type="button" class="reset-link" [disabled]="isLoading" (click)="resent.emit()">Resend OTP</button>
  <button type="button" class="reset-link back" [disabled]="isLoading" (click)="backed.emit()">Back to login</button>
</div>
